module.exports = __webpack_public_path__ + "img/img3.be8c34ed.png";